// src/enums/employee.ts
import { Timestamp } from 'firebase/firestore';

export const EMPLOYEE_ROLES = [
  'Sales Executive', 'Branch Manager', 'Mechanic / Technician', 'Accountant',
  'Import Coordinator', 'Receptionist', 'Cleaner / Valet', 'Admin Staff', 'Other',
] as const;
export type EmployeeRole = typeof EMPLOYEE_ROLES[number];

export const EMPLOYEE_STATUSES = ['Active', 'On Leave', 'Suspended', 'Terminated'] as const;
export type EmployeeStatus = typeof EMPLOYEE_STATUSES[number];

export interface Employee {
  id?: string;
  fullName: string;
  nic?: string; // national ID / identity number
  email?: string;
  phone: string;
  address?: string;
  jobRole: EmployeeRole;
  branchId?: string;
  branchName?: string;
  basicSalary: number;
  commissionRate?: number; // % commission on each car sold, for sales staff
  joinDate: string; // ISO date string
  status: EmployeeStatus;
  bankName?: string;
  bankAccountNumber?: string;
  notes?: string;
  createdAt?: Date | Timestamp;
  updatedAt?: Date | Timestamp;
  createdBy?: string;
}

export interface EmployeeFormData {
  fullName: string;
  nic: string;
  email: string;
  phone: string;
  address: string;
  jobRole: string;
  branchId: string;
  basicSalary: string;
  commissionRate: string;
  joinDate: string;
  status: string;
  bankName: string;
  bankAccountNumber: string;
  notes: string;
}
